import http from './api'
import { GolfHoleResult, GolfPlayerRound, GolfShot } from '../types/golfPlay'

class GolfPlayService {
  async startRound(roomId: string, startHole = 1): Promise<GolfPlayerRound> {
    const response = await http.post(`/golf-play/room/${roomId}/rounds`, { startHole })
    return response.data
  }

  async getActiveRound(roomId: string): Promise<GolfPlayerRound | null> {
    const response = await http.get(`/golf-play/room/${roomId}/rounds/active`)
    return response.data || null
  }

  async recordShot(
    roomId: string,
    roundId: string,
    data: { holeNumber: number; club?: string; distanceMeters?: number; lie?: string; outcome?: string },
  ): Promise<GolfShot> {
    const response = await http.post(`/golf-play/room/${roomId}/rounds/${roundId}/shots`, data)
    return response.data
  }

  async completeHole(
    roomId: string,
    roundId: string,
    data: {
      holeNumber: number
      par: number
      strokes: number
      fairwayHit: boolean
      longestDrive: boolean
      closestToPin: boolean
    },
  ): Promise<{ round: GolfPlayerRound; hole: GolfHoleResult }> {
    const response = await http.post(`/golf-play/room/${roomId}/rounds/${roundId}/complete-hole`, data)
    return response.data
  }

  async getRoundDetails(
    roomId: string,
    roundId: string,
  ): Promise<{ round: GolfPlayerRound; holes: GolfHoleResult[]; shots: GolfShot[] }> {
    const response = await http.get(`/golf-play/room/${roomId}/rounds/${roundId}`)
    return response.data
  }
}

const golfPlayService = new GolfPlayService()
export default golfPlayService

